/* @sravni/react-header version 0.2.43 */
import { __read } from 'tslib';

function formatKey(key) {
    var _a = __read(key.split('-')), start = _a[0], rest = _a.slice(1);
    return "" + start + (!rest ? '' : rest.map(function (k) { return "" + k[0].toUpperCase() + k.slice(1); }).join(''));
}
var getCustomStyles = function (item) {
    var _a;
    var style = {};
    if ((_a = item.customStyle) === null || _a === void 0 ? void 0 : _a.length) {
        style = item.customStyle
            // .replace(/ /g, '')
            .split(';')
            .reduce(function (output, item) {
            var _a = __read(item.split(':'), 2), key = _a[0], value = _a[1];
            if (key && value) {
                output[formatKey(key)] = value;
            }
            return output;
        }, {});
    }
    return style;
};

export { getCustomStyles };
//# sourceMappingURL=styles.js.map
